<template>
  <v-card height="300px" class="elevation-0">
    <v-card-title class="title"> Atendimento {{ dateFormatted }} </v-card-title>
    <v-card-text>
      <div v-for="medico in medicosHorarios" :key="medico.id" class="card-horario">
        <div class="medico">
          <div class="medico-avatar">
            {{ getInitials(medico.nome) }}
          </div>
          <div>
            {{ medico.nome }}
          </div>
        </div>
        <div class="list-horarios">
          <div
            v-for="agenda in medico.horarios"
            :key="agenda.id"
            @click="$emit('update:selectedHorario', agenda.id)"
            class="horario"
            :class="{ active: selectedHorario === agenda.id }"
          >
            {{ formatHorarioLocal(agenda.horario) }}
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="$emit('update-step', 2)">
        Voltar
      </v-btn>
      <v-btn color="primary" :disabled="!selectedHorario" @click="$emit('on-submit')">
        Confirmar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { format, parse, subHours } from 'date-fns'

export default {
  props: {
    medicosHorarios: {
      required: true
    },
    date: {
      required: true
    },
    selectedHorario: {
      type: Number
    }
  },
  computed: {
    dateFormatted() {
      const date = parse(this.date, 'yyyy-MM-dd', new Date())
      return date.toLocaleDateString('pt-br')
    }
  },
  methods: {
    format,
    formatHorarioLocal(horarioUtc) {
      const date = new Date(horarioUtc)
      const offsetMinutes = date.getTimezoneOffset()
      const offsetHours = offsetMinutes / 60
      const localDate = subHours(date, offsetHours)
      const result = format(localDate, 'HH:mm')
      
      if (result && result !== 'Invalid Date') return result

      // Fallback UTC-3 (Brasília)
      const brt = subHours(date, 3)
      return format(brt, 'HH:mm')
    },
    updateHorarioSelected(id) {
      this.$emit('select-horario', id)
    },
    getInitials(name) {
      const rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu')

      let initials = [...name.matchAll(rgx)] || []

      return (initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase())
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 1.1rem !important;
}

.card-horario {
  display: flex;
  height: 15vh;
  padding: 10px;
  border-radius: 10px;
  justify-content: space-around;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}
.medico {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 30%;
}

.medico-avatar {
  border-radius: 50%;
  background-color: #055dff;
  width: 50px;
  height: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.list-horarios {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.horario {
  padding: 6px;
  margin: 5px;
  font-size: 0.9rem;
  max-height: 33px;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #055dff;
  color: #055dff;
  cursor: pointer;
}

.active,
.horario:hover {
  color: #fff;
  background-color: #055dff;
}
</style>
